'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = 'M501.9 10.1c-7-7-16.7-10.8-26.6-10L458.7 1.7c-87.2 9.7-235.8 44.5-321.3 129.9l-7.3 7.5C57.3 217.3 57.2 304 71.3 356.4l2.4 7.3c5.4 14.3 14.5 26.9 25 38.2L2.4 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L110 413.3c13.2 12.3 28.2 22.7 45.6 27.4l10.6 2.5c53 11.3 133.6 6.8 206.7-61.3l7.5-7.3c85.4-85.4 120.2-234.1 129.9-321.3l1.6-16.6c.8-9.9-3-19.6-10-26.6zM121.3 402l66-66 205.7 0c-7.5 9.7-15.4 18.9-23.9 27.3-70.5 70.5-148.9 75.1-199.6 64.3l-9.8-2.4c-13.8-3.7-26.3-12.1-38.4-23.2zm283.2-82l-201.2 0 80-80 163.6 0c-11.7 28.2-25.7 55.5-42.4 80zm48.7-96l-154 0 51.2-51.2c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L110 390.7c-9.5-10.3-17-21-21.3-32.5l-1.9-5.9c-13.5-49.9-13.3-134.2 61.9-209.3 43.1-43.1 104-73.2 165.4-93.5 53.6-17.7 106.6-27.4 146.3-31.8l16.2-1.6c5-.4 10.1 1.5 14 5.4 2.9 2.9 4.7 6.6 5.2 10.3l.1 3.8c-3.3 40.8-13.2 101.2-33.4 162.4-2.9 8.7-5.9 17.4-9.2 26.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;